package com.parmartechnologies.core.feature.address.network

import com.parmartechnologies.core.feature.address.model.LocationCoordinate
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

@Serializable
data class CreateAddressRequest @OptIn(ExperimentalTime::class) constructor(
    @SerialName("user_id") var UserID: String = "",
    @SerialName("business_id") val BusinessID: String = "",
    @SerialName("feature_object_id") var FeatureObjectID: String = "",
    @SerialName("name") var Name: String = "",
    @SerialName("zip_code") var ZipCode: Long = 0,
    @SerialName("country") var Country: String = "IN",
    @SerialName("state") var State: String = "",
    @SerialName("city") var City: String = "",
    @SerialName("area") var Area: String = "",
    @SerialName("land_mark") var LandMark: String = "",
    @SerialName("house") var House: String = "",
    @SerialName("flat_number") var FlatNumber: String = "",
    @SerialName("floor") var Floor: String = "",
    @SerialName("mobile_number") var MobileNumber: String = "",
    @SerialName("dial_code") var DialCode: String = "",
    @SerialName("type") var Type: String = "",
    @SerialName("location") var Location: LocationCoordinate = LocationCoordinate(),
    @SerialName("is_primary") var IsPrimary: Int = 0,
    @SerialName("is_deleted") var IsDeleted: Int = 0,
    @SerialName("created_at") val CreatedAt: LocalDateTime = Clock.System.now().toLocalDateTime(
        TimeZone.UTC),
    @SerialName("updated_at") val UpdatedAt: LocalDateTime = Clock.System.now().toLocalDateTime(
        TimeZone.UTC),
)

@Serializable
data class UpdateAddressRequest @OptIn(ExperimentalTime::class) constructor(
    @SerialName("_id") val id: String = "",
    @SerialName("business_id") val BusinessID: String = "",
    @SerialName("user_id") val UserID: String,
    @SerialName("feature_object_id") val featureObjectID: String = "",
    @SerialName("name") val name: String = "",
    @SerialName("unique_id") var uniqueId: Long = Clock.System.now().epochSeconds,
    @SerialName("zip_code") var ZipCode: Long = 0,
    @SerialName("country") var Country: String = "IN",
    @SerialName("state") var State: String = "",
    @SerialName("city") var City: String = "",
    @SerialName("area") var Area: String = "",
    @SerialName("land_mark") var LandMark: String = "",
    @SerialName("house") var House: String = "",
    @SerialName("flat_number") var FlatNumber: String = "",
    @SerialName("floor") var Floor: String = "",
    @SerialName("mobile_number") var MobileNumber: String = "",
    @SerialName("dial_code") var DialCode: String = "",
    @SerialName("type") var Type: String = "",
    @SerialName("location") var Location: LocationCoordinate = LocationCoordinate(),
    @SerialName("is_primary") var IsPrimary: Int = 0,
    @SerialName("is_deleted") val isDeleted: Int = 0,
    @SerialName("created_at") val CreatedAt: LocalDateTime = Clock.System.now().toLocalDateTime(
        TimeZone.UTC),
    @SerialName("updated_at") val UpdatedAt: LocalDateTime = Clock.System.now().toLocalDateTime(
        TimeZone.UTC),
)

@Serializable
data class RetrieveAddressRequest(
    @SerialName("business_id") val BusinessID: String,
    @SerialName("user_id") val UserID: String = "",
    @SerialName("feature_object_id") val featureObjectID: String = "",
)

@Serializable
data class FindZipCodeRequest(
    @SerialName("PinCode") val pinCode: String,
    @SerialName("country") val country: String,
)
